const maxNumberOfSupportedTasks = 2000;

export const canHandleNumberOfTasks = (numberOfTasks: number) => {
    return numberOfTasks > 0 && numberOfTasks <= maxNumberOfSupportedTasks;
};
